<template>
  <div class="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <div class="text-center">
        <h1 class="text-3xl font-bold text-gray-900 mb-2">Auto Facturación</h1>
        <p class="text-gray-600">Genera tu factura de manera fácil y rápida</p>
      </div>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white py-8 px-4 shadow-xl rounded-lg sm:px-10">
        <form @submit.prevent="buscarOrden" class="space-y-6">
          <div>
            <label for="numeroOrden" class="block text-sm font-medium text-gray-700">
              Número de Orden
            </label>
            <div class="mt-1">
              <input
                id="numeroOrden"
                name="numeroOrden"
                type="text"
                v-model="numeroOrden"
                required
                placeholder="Ingresa tu número de orden"
                class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                :class="{ 'border-red-500': error }"
              />
            </div>
            <p v-if="error" class="mt-2 text-sm text-red-600">{{ errorMessage }}</p>
          </div>

          <div>
            <button
              type="submit"
              :disabled="loading || !numeroOrden.trim()"
              class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <span v-if="loading" class="flex items-center">
                <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Buscando...
              </span>
              <span v-else>Buscar Orden</span>
            </button>
          </div>
        </form>

        <!-- Información adicional -->
        <div class="mt-8 pt-6 border-t border-gray-200">
          <div class="text-center">
            <h3 class="text-sm font-medium text-gray-700 mb-3">¿No tienes tu número de orden?</h3>
            <p class="text-xs text-gray-500 mb-4">
              El número de orden se encuentra en tu confirmación de compra o recibo.
            </p>
            <div class="bg-gray-50 p-4 rounded-md">
              <p class="text-xs text-gray-600">
                <strong>Ejemplo:</strong> ORD-2024-001234
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="mt-12 text-center">
      <p class="text-sm text-gray-500">
        ¿Necesitas ayuda? Contáctanos al 
        <a href="tel:+1234567890" class="text-indigo-600 hover:text-indigo-500">123-456-7890</a>
      </p>
    </div>
  </div>
</template>

<script>
import facturacionService from '@/Services/facturacion';
import { clasificarErrorOrden } from '@/functions/clasificarErrorOrden';

export default {
  name: 'BuscarOrden',
  data() {
    return {
      numeroOrden: '',
      loading: false,
      error: false,
      errorMessage: ''
    };
  },
  methods: {
    async buscarOrden() {
      this.loading = true;
      this.error = false;
      this.errorMessage = '';

      try {
        const response = await facturacionService.BUSCAR_ORDEN_PUBLICA({
          numero_orden: this.numeroOrden.trim()
        });

        if (response.success) {
          // Redirigir a la vista de facturación con los datos de la orden
          this.$router.push({
            name: 'crear-factura',
            params: {
              ordenId: response.data.id
            },
            query: {
              numero: this.numeroOrden.trim()
            }
          });
        } else {
          this.error = true;
          this.errorMessage = clasificarErrorOrden(response.message);
        }
      } catch (error) {
        // Error inesperado no capturado por normalizarRespuesta
        this.error = true;
        this.errorMessage = 'Error de conexión. Verifica tu conexión a internet e intenta nuevamente.';
        console.error('Error buscando orden:', error);
      } finally {
        this.loading = false;
      }
    },

    // Limpiar errores al escribir
    clearError() {
      if (this.error) {
        this.error = false;
        this.errorMessage = '';
      }
    }
  },
  watch: {
    numeroOrden() {
      this.clearError();
    }
  }
};
</script>

<style scoped>
/* Estilos adicionales si son necesarios */
</style>
